/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const privacyNoticeUrls = {
    '18F': 'https://www.1800flowers.com/About-Us-Privacy-Policy',
    TPF: 'https://www.thepopcornfactory.com/About-Us-Privacy-Policy',
    '18B': 'https://www.1800baskets.com/About-Us-Privacy-Policy',
    FB: 'https://www.fruitbouquets.com/About-Us-Privacy-Policy',
    CCO: 'https://www.cheryls.com/About-Us-Privacy-Policy',
    HD: 'https://www.harryanddavid.com/About-Us-Privacy-Policy',
    SCH: 'https://www.simplychocolate.com/About-Us-Privacy-Policy',
    BRY: 'https://www.berries.com/About-Us-Privacy-Policy',
    WLF: 'https://www.wolfermans.com/About-Us-Privacy-Policy',
    VC: 'https://www.vitalchoice.com/About-Us-Privacy-Policy',
    FL: 'https://www.florists.com/About-Us-Privacy-Policy',
    PL: 'https://www.plants.com/privacy-policy'
};